import { ReactNode } from "react";
import { useEntitlements } from "../../hooks/useEntitlements";
import { TFeatureKey } from "../../services/types/users.types";
import { tWithKeyAttr as t } from "../../i18nHelper";

export interface GatedProps {
  feature: TFeatureKey;
  fallback?: ReactNode;
  children: ReactNode;
  showTrialBadge?: boolean;
}

function Gated({ feature, fallback = null, children, showTrialBadge = false }: GatedProps) {
  const { hasFeature, isTrialReduced } = useEntitlements();
  if (hasFeature(feature)) {
    return (
      <>
        {children}
        {showTrialBadge && isTrialReduced(feature) && (
          <span className="trial-badge">
            {t("TRIAL_LIMIT")}
          </span>
        )}
      </>
    );
  }

  return <>{fallback}</>;
}

export default Gated;
